'use client';

import { Container, Grid, Typography } from '@mui/material';
import cx from 'clsx';
import { useTranslations } from 'next-intl';

import ProjectCard from '@/components/ProjectCard';
import { projects } from '@/config/projects.config';
import useScrollReveal from '@/utils/hooks/useScrollReveal';

import styles from './OurWorkSection.module.scss';

interface OurWorkSectionProps {
  onlyFeatured?: boolean;
}

const OurWorkSection = ({ onlyFeatured = false }: OurWorkSectionProps) => {
  const t = useTranslations('home.ourWorkSection');
  const filteredProjects = onlyFeatured ? projects.slice(0, 4) : projects;
  const { setRef, isVisible } = useScrollReveal<HTMLDivElement>(filteredProjects.length);

  return (
    <Container component="section" maxWidth="xl" className={styles.container}>
      <Typography variant="h2" textAlign="center" className={styles.title}>
        {t('title')}
      </Typography>
      <Typography variant="body1" className={styles.description}>
        {t('description')}
      </Typography>
      <Grid container columnSpacing={3} rowSpacing={15} className={styles.grid}>
        {filteredProjects.map((project, index) => (
          <Grid
            key={project.title}
            ref={setRef(index)}
            size={{ xs: 12, md: 6 }}
            className={cx(styles.projectCard, { [styles.visible]: isVisible(index) })}
          >
            <ProjectCard {...project} />
          </Grid>
        ))}
      </Grid>
    </Container>
  );
};

export default OurWorkSection;
